export default __webpack_public_path__ + "static/media/athleteHomePgae.117235dd.jpg";